var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummaryTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C1.34315 0 0 1.34315 0 3V9C0 10.6569 1.34315 12 3 12H7C8.65685 12 10 10.6569 10 9V3C10 1.34315 8.65685 0 7 0H3ZM2 3C2 2.44772 2.44772 2 3 2H7C7.55228 2 8 2.44772 8 3V9C8 9.55229 7.55228 10 7 10H3C2.44772 10 2 9.55228 2 9V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 10C13.3431 10 12 11.3431 12 13V19C12 20.6569 13.3431 22 15 22H19C20.6569 22 22 20.6569 22 19V13C22 11.3431 20.6569 10 19 10H15ZM14 13C14 12.4477 14.4477 12 15 12H19C19.5523 12 20 12.4477 20 13V19C20 19.5523 19.5523 20 19 20H15C14.4477 20 14 19.5523 14 19V13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C12 1.34315 13.3431 0 15 0H19C20.6569 0 22 1.34315 22 3V5C22 6.65685 20.6569 8 19 8H15C13.3431 8 12 6.65685 12 5V3ZM15 2C14.4477 2 14 2.44772 14 3V5C14 5.55228 14.4477 6 15 6H19C19.5523 6 20 5.55228 20 5V3C20 2.44772 19.5523 2 19 2H15Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 14C1.34315 14 0 15.3431 0 17V19C0 20.6569 1.34315 22 3 22H7C8.65685 22 10 20.6569 10 19V17C10 15.3431 8.65685 14 7 14H3ZM2 17C2 16.4477 2.44772 16 3 16H7C7.55228 16 8 16.4477 8 17V19C8 19.5523 7.55228 20 7 20H3C2.44772 20 2 19.5523 2 19V17Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryTab);
export default __webpack_public_path__ + "static/media/summary-tab.0847b7e5.svg";
export { ForwardRef as ReactComponent };